var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilterPlus = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 2,
  y: 3,
  fill: "currentColor",
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 2,
  x: 3,
  y: 7,
  fill: "currentColor",
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 2,
  x: 5,
  y: 11,
  fill: "currentColor",
  rx: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 2,
  x: 10,
  y: 11,
  fill: "currentColor",
  rx: 1
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 2,
  x: 12,
  y: 15,
  fill: "currentColor",
  rx: 1,
  transform: "rotate(-90 12 15)"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterPlus);
export default ForwardRef;